<script setup lang="ts">
import SupportContent from "@/support/SupportContent.vue";
</script>

<template>
  <SupportContent />
</template>
